export default "__VITE_ASSET__0G8o7zDBHnn2cgQ8q22_zA__"